<template>
  <el-container class="default-layout">
    <the-aside></the-aside>
    <el-container>
      <el-header>
        <the-header></the-header>
      </el-header>
      <el-page-header
        :class="['page-header', showBack ? '' : 'page-header_root']"
        :content="title" title="Назад"
        @back="goBack"/>
      <div :class="['page-main-wrapper', leftMenuVisible ? '' : 'page-main-wrapper_left-hidden']">
        <div class="page-main-wrapper__content">
          <el-main :style="{paddingBottom: '20px'}" class="main-block" id="main-block">
            <router-view/>
          </el-main>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import TheAside from '@/components/TheAside'
import TheHeader from '@/components/TheHeader'

export default {
  name: 'default',
  components: {
    TheHeader,
    TheAside
  },
  data: () => {
    return {
      isMounted: false
    }
  },
  computed: {
    ...mapState('loader', {
      loading: state => state.loading
    }),
    leftMenuVisible () {
      if (!this.isMounted || !this.$refs.leftMenu) {
        return false
      }
      return 0
    },
    title () {
      return this.$route.meta.title
    },
    showBack () {
      return !!this.$route.meta.back
    }
  },
  methods: {
    goBack () {
      if (this.$route.meta.back) { this.$router.push({ name: this.$route.meta.back }) }
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 350px) {
  .el-page-header {
    display: block;

    .el-page-header__content {
      padding: 15px 0 0 0;
    }
  }
}

@media only screen and (max-width: 500px) {
  .default-layout {
    display: block;
  }
}

.main-block {
  padding-top: 25px;
  background-color: #f3f3f3;

}
.default-layout {
  height: 100vh;

  .el-header {
    background: #5AC9AD;
    text-align: right;
    margin-right: 0;
    padding: 10px;
  }

  .el-main {
    //padding-top: 0 !important;
    padding-bottom: 0 !important;
    position: relative;
  }

  .infinite-status-prompt {
    font-size: 25px;
    margin-top: 25px;
    color: #e0e0e0;
  }

  .page-header {
    padding: 18px;
    margin: 0;

    background: #f3f3f3;
    position: relative;

    &::after {
      content: '';
      border-bottom: 1px #e8e8e8 solid;
      width: calc(100% - 40px);

      position: absolute;
      bottom: 0;
    }

    &_root .el-page-header__left {
      display: none !important;
    }
  }

  .page-main-wrapper {
    flex-direction: row;
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: auto;

    &__left-panel {
      flex: 0 200px;
      background: #f6f5f3;
      position: relative;
      min-width: 200px;
      overflow: auto;
    }

    &__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 200px);
    }

    &_left-hidden {
      .page-main-wrapper__left-panel {
        flex: 0;
        min-width: auto;
      }

      .page-main-wrapper__content {
        max-width: 100%;
      }
    }
  }

}

</style>
